<script setup>
import { computed, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: undefined,
  },
  selectOptions: {
    type: Array,
    required: true,
  },
  presence: {
    type: Boolean,
    default: false,
  },
  autoDefault: {
    type: Boolean,
    default: false,
  },
  mainColor: {
    type: String,
    required: true,
  },
  borderColor: {
    type: String,
    default: undefined,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  textFont: {
    type: String,
    default: 'null',
  },
  borderRadius: {
    type: String,
    default: '20px',
  },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit('update:modelValue', val);
  },
});

watch(
  () => props.selectOptions,
  async (el) => {
    if (props.autoDefault) {
      if (el.length === 0) {
        return;
      }

      if (!el.includes(model.value)) {
        model.value = el[0];
      }

      if (el.length === 1) {
        model.value = el[0];
      }
    }
  },
);

const computedBorderColor = computed(() => {
  return props.borderColor || props.mainColor;
});
</script>

<template>
  <div class="input">
    <p v-if="$slots.default" class="custom-font">
      <slot></slot>
    </p>
    <q-select
      v-model="model"
      borderless
      class="core-default-input-form input-form"
      :options="selectOptions"
      lazy-rules
      :rules="[(presence && ((val) => !!val)) || 'To pole nie może być puste']"
    />
  </div>
</template>

<style lang="scss">
/* stylelint-disable selector-class-pattern */
.q-item.q-router-link--active,
.q-item--active {
  color: v-bind(backgroundColor);
}

.q-field__control-container,
.q-select__dropdown-icon {
  color: v-bind(mainColor);
}
/* stylelint-enable selector-class-pattern */
</style>

<style lang="scss" scoped>
@import './inputs';

.input-form {
  border: 1px solid v-bind(computedBorderColor);
  border-radius: v-bind(borderRadius);
  background-color: v-bind(backgroundColor);
  color: v-bind(mainColor);

  &:focus-within {
    border: 1px solid v-bind(computedBorderColor);
  }
}

.custom-font {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
}
</style>
